import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import { InputSwitch } from 'primereact/inputswitch';
import {Dropdown} from "primereact/dropdown";

const TechnologyFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({});
  const [newFormData, setNewFormData] = useState({});
  const [units, setUnits] = useState([]);

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if ((window.App.urlVars().technologyId) || (entity === 'technology' && id)) {
      apiCall('patch', '/api/v2/technology/' + (window.App.urlVars().technologyId ?? id), newFormData)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderTechnologyList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/technology', {...data, ...formData})
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderTechnologyList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/project/technology/update/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  useEffect(() => {
    apiCall('get', '/api/v2/unit?sort=name&direction=asc&item_per_page=200')
      .then(response => setUnits(response?.data?.data?.items || []))
      .catch(error => window.App.toastShow('error', t('error'), error.toString(), '', error.response));

    if ((!window.App.urlVars().create && window.App.urlVars().technologyId) || (entity === 'technology' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/technology/' + (window.App.urlVars().technologyId ?? id))
        .then(response => {
          setFormData(response.data.data)
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

  return (
    <div className={"tmp-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="default_unit" render={({meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="default_unit"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldDefaultUnit')}</label>
                  <Dropdown
                    id="default_unit"
                    value={formData.default_unit?.id || formData.default_unit || null}
                    options={units}
                    optionLabel="name"
                    optionValue="id"
                    showClear
                    filter
                    emptyMessage={t('noSelectableItemYet')}
                    onChange={(e) => {
                      setFormData({...formData, default_unit: e.value});
                      setNewFormData({...newFormData, default_unit: e.value});
                    }}
                  />
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-4"}>
              <Field name="active" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="active"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldActive')}</label>
                  <span className="p-d-block">
                      <InputSwitch 
                                //  id="active" {...input}
                                    checked={formData.active}

                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     active: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     active: e.target.value
                                   })
                                 }}
                                 value={formData.active}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            {((localStorage.getItem('roles') || '') + '').toUpperCase().includes('ROLE_SUBCONTRACTOR_READ') && (
              <div className={"p-col-12 p-lg-4"}>
              <Field name="subcontractor" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="subcontractor"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldSubcontractor')}</label>
                  <span className="p-d-block">
                      <InputSwitch 
                                //  id="active" {...input}k
                                    checked={formData.subcontractor}

                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     subcontractor: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     subcontractor: e.target.value
                                   })
                                 }}
                                 value={formData.subcontractor}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            )}
            
            {((localStorage.getItem('roles') || '') + '').toUpperCase().includes('ROLE_SCHEDULE_READ') && (
            <div className={"p-col-12 p-lg-4"}>
              <Field name="schedule" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="schedule"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldSchedule')}</label>
                  <span className="p-d-block">
                      <InputSwitch 
                                //  id="active" {...input}k
                                    checked={formData.schedule}

                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     schedule: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     schedule: e.target.value
                                   })
                                 }}
                                 value={formData.schedule}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            )}
            
            {((localStorage.getItem('roles') || '') + '').toUpperCase().includes('ROLE_STANDARD_TIME_READ') && (
            <div className={"p-col-12 p-lg-4"}>
              <Field name="standard_time" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="standard_time"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldNormTime')}</label>
                  <span className="p-d-block">
                      <InputSwitch 
                                //  id="active" {...input}
                                    checked={formData.standard_time}

                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     standard_time: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     standard_time: e.target.value
                                   })
                                 }}
                                 value={formData.standard_time}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          )}
          {((localStorage.getItem('roles') || '') + '').toUpperCase().includes('ROLE_ASSIGNABLE_READ') && (
            <div className={"p-col-12 p-lg-4"}>
              <Field name="employee_assignable" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="employee_assignable"
                        className={classNames({'p-error': isFormFieldValid(meta)})}>
                    {props.t('fieldEmployeeAssignable')}
                  </label>
                  <span className="p-d-block">
                    <InputSwitch
                      checked={!!formData.employee_assignable}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          employee_assignable: e.target.value
                        })
                        setNewFormData({
                          ...newFormData,
                          employee_assignable: e.target.value
                        })
                      }}
                      value={formData.employee_assignable}
                      className={classNames({'p-invalid': isFormFieldValid(meta)})}
                    />
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          )}

          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>

            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'technology' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(TechnologyFormComponent);
